<template>
    <div class="flex flex-col md:flex-row items-center md:items-start text-center md:text-left justify-between w-full mx-auto p-5 ">
        <div class="flex flex-col md:flex-row items-center">
            <img v-if="subscription.src" class="h-20 w-20 md:mr-3 mb-5 md:mb-0 object-contain" :src="subscription.src" />

            <div v-else class="h-20 w-20 md:mr-3 mb-5 md:mb-0 bg-gray-200 flex rounded">
                <svg class="text-gray-500 h-8 w-8 m-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
            </div>

            <div class="flex flex-col md:ml-5">
                <span class="text-xl text-xiaomi">{{ subscription.product_model }}</span>
                <span class="text-gray-600" v-if="subscription.imei">IMEI : {{ subscription.imei }}</span>
                <span class="text-gray-600" v-if="subscription.product_serial">Numéro de série : {{ subscription.product_serial }}</span>
                <span class="text-gray-600" v-if="subscription.type == 'phone_breakage'">Téléphone : Oxydation / Casse</span>
                <span class="text-sm text-blue-500 font-thin mt-4">Notice d'information<br> Fiche simplifiée</span>
            </div>
        </div>

        <div class="flex flex-col items-end text-center md:text-right mt-8 md:mt-0">
            <div class="flex flex-col mr-3">
                <span class="flex justify-center md:justify-end items-center text-green-500 text-sm" v-if="subscription.can_claim">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 " fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>

                    <span class="">Garantie active</span>
                </span>

                <span class="flex justify-end items-center text-red-500 text-sm" v-else>
                    <span class="">Garantie utilisée ou expirée</span>
                </span>

                <span class="text-sm text-green-800" v-if="subscription.can_claim">Depuis le {{ subscription.verbose_subscribed_at }}</span>
            </div>

            <router-link v-if="subscription.can_claim" :to="'/client/claim/' + subscription.type + '/' + subscription.id" tag="button" class="mt-3 rounded-full text-sm p-3 px-5 leading-none cursor-pointer border-2 border-xiaomi bg-orange-100 hover:bg-orange-200 text-xiaomi rounded disabled:opacity-75 disabled:cursor-not-allowed  focus:outline-none focus:shadow-outline">Déclarer un sinistre</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: ['subscription']
}
</script>